module.exports = __webpack_public_path__ + "img/vol06_cup02_cover02.a4d75a46.jpg";